import React, { useState, useEffect } from "react";
import { Paper } from "@material-ui/core";
import { baseUrl } from "../../../../services/config";
import { Table, Modal, Spinner } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useAlert } from "react-alert";
import Select from "react-select";
const RollBackInvoice = () => {
  const authtoken = localStorage.getItem("userToken");
  const [loading, setLoading] = useState(false);

  const [allsessions, setallsessions] = useState([]);
  const [currentsession, setcurrentsession] = useState("");
  const alert = useAlert();

  const [searchInvoice, setSearchInvoice] = useState("");
  const [allInvoicesList, setAllInvoicesList] = useState([]);
  const [allSubAccounts, setAllSubAccounts] = useState([]);

  const [editInvoicePayModal, setEditInvoicePayModal] = useState(false);
  const [editPayAmount, setEditPayAmount] = useState(0);
  const [editPaySubAccountId, setEditPaySubAccountId] = useState("");
  const [editInvoicePayId, setEditInvoicePayId] = useState("");

  const [deleteModal, setDeleteModal] = useState(false);
  const [deletePayInvoiceId, setDeletePayInvoiceId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    getAllSessions();
    getBanksSubAccounts();
  }, []);

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setallsessions(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setcurrentsession(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getBanksSubAccounts = async () => {
    await fetch(`${baseUrl}/bank-and-cash-sub-accounts`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          let arr = [];
          data.payload.forEach((element) => {
            arr.push({
              label: element.title + `(${element.acode})`,
              value: element.id,
            });
          });
          setAllSubAccounts(arr);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getInvoices = () => {
    if (searchInvoice == "") {
      alert.error("Enter Invoice Number");
      return;
    }

    setLoading(true);

    const data = {
      session_id: currentsession,
      school_account_id: "",
      invoice_number: searchInvoice,
      months: [],
      payment_status: [3],
    };

    fetch(`${baseUrl}/search-invoices`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.metadata.success) {
          if (data?.payload?.length == 0) {
            setAllInvoicesList([]);
          }
          setAllInvoicesList(data?.payload[0]?.invoice_payments);
          setLoading(false);
        } else {
          alert.error(data.metadata.message);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);
      });
  };

  const updateInvoicePayHandler = async () => {
    if (editPayAmount == "") {
      return alert.error("Amount Is Required");
    }

    setSubmitLoading(true);
    const data = {
      session_id: currentsession,
      sub_account_id: editPaySubAccountId,
      received_amount: editPayAmount,
    };

    await fetch(`${baseUrl}/invoice-payments/${editInvoicePayId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Invoice Payment Successfully Updated");
            setEditPayAmount(0);
            setEditInvoicePayId("");
            getInvoices();
            setEditInvoicePayModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditInvoicePayModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditInvoicePayModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deletePayInvoiceHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/invoice-payments/${deletePayInvoiceId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(data.metadata.message);
            getInvoices();
            setdeleteloading(false);
            setDeleteModal(false);
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setdeleteloading(false);
            setDeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setDeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setdeleteloading(false);
        setDeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mt-3">
          <div className="col-md-4">
            <label>
              <b>Enter Invoice Number</b>
            </label>
            <input
              onChange={(e) => setSearchInvoice(e.target.value)}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  getInvoices();
                }
              }}
              className="form-control"
              placeholder="Enter Invoice Number"
            />
          </div>

          <div className=" d-flex col-md-8 mt-9">
            <button
              type={"submit"}
              onClick={getInvoices}
              className="btn btn-primary mr-4"
            >
              Get Invoice
            </button>
          </div>
        </div>

        <div className="table-responsive">
          <Table className="mt-5">
            <thead>
              <tr id="tbl" className="text-center">
                <th>Sr No.</th>
                <th>Sub Account</th>
                <th>Description</th>
                <th>Total Amount</th>
                <th>Paid Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(allInvoicesList) &&
                allInvoicesList?.map((invoice, index) => (
                  <tr>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">
                      {invoice?.sub_account?.title} (
                      {invoice?.sub_account?.acode})
                    </td>
                    <td className="text-center">{"Paid Amount"}</td>
                    <td className="text-center">
                      {Intl.NumberFormat("en-Us").format(
                        invoice?.invoice?.payable
                      )}
                    </td>
                    <td className="text-center">
                      {Intl.NumberFormat("en-Us").format(
                        invoice?.received_amount
                      )}
                    </td>
                    {invoice?.voucher_id == null ? (
                      <td className="text-center">
                        <a
                          className="btn btn-icon btn-light btn-hover-primary-custom btn-sm "
                          onClick={() => {
                            setEditInvoicePayId(invoice?.id);
                            setEditPayAmount(invoice?.received_amount);
                            setEditPaySubAccountId(invoice?.sub_account_id);
                            setEditInvoicePayModal(true);
                          }}
                        >
                          <span className="svg-icon text_align_start svg-icon-md svg-icon-primary-custom">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Write.svg"
                              )}
                            />
                          </span>
                        </a>

                        <a
                          className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                          onClick={() => {
                            setDeletePayInvoiceId(invoice?.id);
                            setDeleteModal(true);
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Delete-user.svg"
                              )}
                            />
                          </span>
                        </a>
                      </td>
                    ) : (
                      <td
                        style={{
                          color: "green",
                        }}
                      >
                        Paid
                      </td>
                    )}
                  </tr>
                ))}
              {Array.isArray(allInvoicesList) && allInvoicesList.length == 0 ? (
                <tr>
                  <td className="text-center" colSpan="5">
                    No Payment Found
                  </td>
                </tr>
              ) : null}
            </tbody>
          </Table>
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner class="text-center" variant="info" animation="border" />
          </div>
        ) : null}

        {/* Update Invoice Payment Modal */}
        <Modal show={editInvoicePayModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Invoice Payment
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6 mb-4">
                <label className="form-control-label">
                  <b>
                    Enter Amount <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editPayAmount}
                  onChange={(e) => setEditPayAmount(e.target.value)}
                  placeholder="Enter Amount"
                />
              </div>

              <div className="col-md-6 mb-4">
                <label class="form-control-label">
                  <b>
                    Select Sub Account
                    <span style={{ color: "red", fontSize: 12 }}>*</span>
                  </b>
                </label>
                <Select
                  value={
                    allSubAccounts?.find(
                      (opt) => opt.value == editPaySubAccountId
                    ) || ""
                  }
                  onChange={(e) => setEditPaySubAccountId(e.value)}
                  placeholder="Select Sub Account"
                  options={allSubAccounts}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateInvoicePayHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditInvoicePayModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Invoice Payment Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this invoice payment?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Invoice Payment Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deletePayInvoiceHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setDeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
};

export default RollBackInvoice;
